import React from "react";
import {Modal} from "react-bootstrap";
import Views from "./views";
import ShopeePlatformOrderImporterProvider from "./provider";

interface ShopeePlatformOrderImporterType {
  onClose: () => void;
  show: boolean;
  code: any;
  orderId: string;
  storeId: string;
  provider: string;
  fromExistOrder: boolean
}

const ShopeePlatformOrderImporter = (props: ShopeePlatformOrderImporterType) => {

  return (
    <ShopeePlatformOrderImporterProvider fromExistOrder={props.fromExistOrder}>
      <Modal show={props.show} onHide={props.onClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            Nhập đơn Shopee { props.code }
          </Modal.Title>
        </Modal.Header>
        <Views
          id={props.orderId}
          show={props.show}
          close={props.onClose}
          storeId={props.storeId}
          provider={props.provider}/>
      </Modal>
    </ShopeePlatformOrderImporterProvider>
  )
}

export default ShopeePlatformOrderImporter;